import { ModelDocument } from "@pjs/storage";
import { Observable, share, startWith, switchMap } from "@pjs/observables";
import { Immutable } from "@pjs/utilities";
import { IAuthorisedDevicesModel } from "./interfaces/IAuthorisedDevicesModel";
import { getAuthorisedDevices } from "./functions/GetAuthorisedDevices.function";
import { AuthorisedDevicesState } from "./enums/AuthorisedDevicesState";
import { IAuthorisedDevices } from "./interfaces/IAuthorisedDevices";

export class AuthorisedDevices implements IAuthorisedDevices {
    private _document: ModelDocument<IAuthorisedDevicesModel> | null = null;

    public getDocument(): ModelDocument<IAuthorisedDevicesModel> {
        if (this._document === null) {
            throw new Error("AuthorisedDevices document is not ready. AuthorisedDevices.load() should be called before attempting to access its data");
        }

        return this._document;
    }

    public getModel(): Observable<Immutable<IAuthorisedDevicesModel>> {
        if (this._document === null) {
            throw new Error("AuthorisedDevices document is not ready. AuthorisedDevices.load() should be called before attempting to access its data");
        }

        return this._document.model.pipe(startWith(this._document.model.get() as Immutable<IAuthorisedDevicesModel>));
    }

    public load(): Observable<Immutable<IAuthorisedDevicesModel>> {
        if (this._document !== null) {
            return this._document.model.pipe(startWith(this._document.model.get() as Immutable<IAuthorisedDevicesModel>));
        }

        return getAuthorisedDevices().pipe(
            switchMap((receivedDevices) => {
                this._document = new ModelDocument<IAuthorisedDevicesModel>({
                    devices: receivedDevices,
                    state: {
                        descriptor: AuthorisedDevicesState.Ok
                    }
                });

                return this._document.model.pipe(startWith(this._document.model.get() as Immutable<IAuthorisedDevicesModel>));
            }),
            share()
        );
    }

    public clear(): void {
        if (this._document !== null) {
            this._document.destroy();
            this._document = null;
        }
    }
}
